module.exports = __webpack_public_path__ + "img/select-chevron.ca8eab47.svg";